import {useEffect, useState} from 'react'
import blueLeftChevron from '../media/blue_left-chevron_icon.svg'
import blueRightChevron from '../media/blue_right-chevron_icon.svg'
import '../styles/Pagination.css'

export const PaginationStatic = (props: any) => {
  const [currentPage, setCurrentPage] = useState(1)
  const [pageNumberLimit] = useState(5)
  const [maxPageNumberLimit, setMaxPageNumberLimit] = useState(5)
  const [minPageNumberLimit, setMinPageNumberLimit] = useState(0)

  useEffect(() => {
    setCurrentPage(1);
  }, [props.pagesDefault])

  const pages = []
  for(let i = 1; i <= props.pagesDefault; i++) {
    pages.push(i);
  }
  
  const handleNavegation = (e: any) => {
    setCurrentPage(Number(e.target.id))
    props.onChangeCurrentPage(Number(e.target.id));
  }

  const handlePrevBtn = () => {
    setCurrentPage(currentPage - 1)
    if ((currentPage - 1) % pageNumberLimit === 0) {
      setMaxPageNumberLimit(maxPageNumberLimit - pageNumberLimit)
      setMinPageNumberLimit(minPageNumberLimit - pageNumberLimit)
    }
    props.onChangeCurrentPage(currentPage - 1);
  }

  const handleNextBtn = () => {
    setCurrentPage(currentPage + 1)
    if (currentPage + 1 > maxPageNumberLimit) {
      setMaxPageNumberLimit(maxPageNumberLimit + pageNumberLimit)
      setMinPageNumberLimit(minPageNumberLimit + pageNumberLimit)
    }
    props.onChangeCurrentPage(currentPage + 1);
  }

  return (
    <>
      {props.pagesDefault > 0 && (
        <div className='pages' style={{marginBottom:'5px'}}>
          {/* {!(currentPage === pages[0]) && ( */}
            <button onClick={handlePrevBtn} className='page page-auto w-inline-block btn-transparent' disabled={currentPage === pages[0]}>
              <img src={blueLeftChevron} loading='lazy' alt='' />
              <div>Anterior</div>
            </button>
          {/* )} */}

          {minPageNumberLimit >= 1 && (
            <button onClick={handlePrevBtn} className='page btn-transparent'>
              &hellip;
            </button>
          )}

          {pages.map((number: number) =>
            number < maxPageNumberLimit + 1 && number > minPageNumberLimit ? (
              <button
                onClick={handleNavegation}
                key={number}
                id={String(number)}
                className={`page btn-transparent ${
                  currentPage === number && 'page-active disable-hover'
                }`}
              >
                {number}
              </button>
            ) : null
          )}

          {pages.length > maxPageNumberLimit && (
            <button onClick={handleNextBtn} className='page btn-transparent'>
              &hellip;
            </button>
          )}

          {/* {!(currentPage === pages[pages.length - 1]) && ( */}
            <button onClick={handleNextBtn} className='page page-auto w-inline-block btn-transparent' disabled={currentPage === pages[pages.length - 1]}>
              <div>Siguiente</div>
              <img src={blueRightChevron} loading='lazy' alt='' />
            </button>
          {/* )} */}
        </div>
      )}
    </>
  )
}
